require('fslightbox');
require('./jquery.flexslider');

// Debounce helper to reduce forced reflows
function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
        const later = () => {
            clearTimeout(timeout);
            func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function getGridSize() {
    return (window.innerWidth < 600) ? 3 :
        (window.innerWidth < 900) ? 3 : 4;
}

// Initialize sliders after DOM is ready and defer to prevent blocking
$(document).ready(function(){
    // Use requestAnimationFrame to defer slider init and reduce forced reflows
    requestAnimationFrame(() => {
        // Product Slider
        if (document.querySelectorAll('#carousel').length > 0) {
            $('#carousel').flexslider({
                animation: "slide",
                animationLoop: true,
                slideshow: false,
                itemWidth: 150,
                itemMargin: 20,
                controlNav: true,
                directionNav: false,
                asNavFor: '#slider',
                minItems: getGridSize(),
                maxItems: getGridSize()
            });
        }
        if (document.querySelectorAll('#slider').length > 0) {
            $('#slider').flexslider({
                animation: "slide",
                controlNav: false,
                directionNav: false,
                animationLoop: false,
                slideshow: false,
                sync: "#carousel"
            });
        }
    });

    let flexSlider = { vars:{} };

    // Debounced resize handler to prevent excessive forced reflows
    $(window).on('resize', debounce(function() {
        let gridSize = getGridSize();
        flexSlider.vars.minItems = gridSize;
        flexSlider.vars.maxItems = gridSize;
    }, 150)); // Wait 150ms after resize stops
});
